import { CONFIG } from '../config';

export function urlFormat(subpath: string): string {
    return `${CONFIG.PUBLIC_PATH}${subpath}`;
}